module.exports = __webpack_public_path__ + "img/box1_price_img2.de5d4031.png";